<template>
  <div class="wp_img">
    <img :src="img">
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      img: require('../assets/1.jpg')
    }
  }
}
</script>

<style scoped lang="less">

</style>